import { render, staticRenderFns } from "./MainBottomCarousel.vue?vue&type=template&id=ee37f3e2&scoped=true"
import script from "./MainBottomCarousel.vue?vue&type=script&lang=js"
export * from "./MainBottomCarousel.vue?vue&type=script&lang=js"
import style0 from "./MainBottomCarousel.vue?vue&type=style&index=0&id=ee37f3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee37f3e2",
  null
  
)

export default component.exports